import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import { isAdvertorial } from '../advertorial/advertorial';
import { figureOutPriorityTag } from '../../../utils/ad_util';

function renderTag(tags) {
  const eyeBrowText = figureOutPriorityTag(tags);
  const slug = eyeBrowText.slug;
  let name = eyeBrowText.name;

  if (!slug || !name) {
    return null;
  }

  name = name
    .replace(/\*/g, '')
    .replace(/_/g, ' ')
    .replace(/\s?advertorial/g, '');

  let to = `/section/${slug}`;

  if (to === '/section/most-creative-people') {
    to = '/most-creative-people';
  }

  return (
    <li className="eyebrow__item">
      {isAdvertorial(tags) ? name : <Link to={to}>{name}</Link>}
    </li>
  );
}

function shouldShowTime(post) {
  const showTime = get(post, 'showTime');
  if (!showTime) return null;
  return <li className="eyebrow__item">{get(post, 'timePublished')} </li>;
}

export default function Eyebrow(props) {
  if (!props) {
    return null;
  }

  const { metadata, post, tags } = props;

  if (!isEmpty(metadata)) {
    const cardTags = metadata.tags || [];
    const category = get(metadata, 'categories[0].name');
    let eyebrow = metadata.site || category || null;

    if (!eyebrow && metadata.dateFormatted && metadata.timePublished) {
      eyebrow = `${metadata.dateFormatted} | ${metadata.timePublished}`;
    }

    if (isAdvertorial(cardTags)) {
      eyebrow = 'Sponsored Content';
    }

    // When it's a News story, it has category Uncategorized
    // we don't want to show that to the user, use date instead
    if (eyebrow === 'Uncategorized') {
      eyebrow = metadata.timePublished;
    }

    if (metadata.customEyebrowText) {
      eyebrow = metadata.customEyebrowText;
    }

    return eyebrow && <span className="eyebrow">{eyebrow}</span>;
  }

  if (!isEmpty(post)) {
    return (
      <ul className="eyebrow">
        <li className="eyebrow__item">{get(post, 'dateFormatted')} </li>
        {shouldShowTime(post)}
        {renderTag(tags)}
      </ul>
    );
  }

  return null;
}

Eyebrow.defaultProps = {
  post: {},
  metadata: {}
};

Eyebrow.propTypes = {
  post: PropTypes.shape({}),
  tags: PropTypes.arrayOf(PropTypes.shape({})),
  metadata: PropTypes.shape({})
};



// WEBPACK FOOTER //
// ./src/views/components/eyebrow/eyebrow.js